import createVueApp from '@phoenix/createVueApp';
import { PhxFocusScrollSequence } from '@phx-styleguides/jlc';

document.querySelectorAll('.phoenix-focus-scroll-sequence').forEach((el) => {
  const app = createVueApp();
  app.component('PhxFocusScrollSequence', PhxFocusScrollSequence);
  app.mount(el);
});
